module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/novara.73b8557ad0e0e85c75d75a208e00a3dc.jpg";